import usePageTitle from "hooks/usePageTitle";
import { UserNotifications } from "routes/user/UserNotifications";
import { UserPreferences } from "routes/user/UserPreferences";
import { UserProfile } from "routes/user/UserProfile";

function UserSettings() {
  usePageTitle("Profile");

  return (
    <div className="tw:w-full tw:self-start tw:flex tw:justify-center">
      <div className="tw:flex tw:flex-col tw:gap-4 tw:w-full tw:max-w-3xl">
        <UserProfile />
        <UserNotifications />
        <UserPreferences />
      </div>
    </div>
  );
}

export default UserSettings;
